import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TableFallback from '../../Components/Loader/TableFallback';
import FormRow from './FormRow';
import { useGetFormsQuery, useNewFormMutation } from '../../Services/apiSlice';
import DeleteFormModal from '../../Components/DeleteFormModal';

export const FormListLoader = () => async () => ({ name: 'Forms' });

const FormListPage = () => {
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const rta = useGetFormsQuery();
  const [newForm, { isLoading }] = useNewFormMutation();
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formDelete, setFormDelete] = useState();

  const handleNewform = async () => {
    const { data } = await newForm();
    console.log(data);
    if (data.status === 'ok') {
      navigate(`/form/${data.form.id}/edit?tab=setup`);
    } else if (data.type === 'MAX_FORMS') {
      toast({
        title: 'Max forms reached',
        description: "You can't create new forms. Please upgrade your plan or delete one of the existing forms",
        status: 'warning',
        variant: 'left-accent',
        isClosable: true,
        position: 'top',
        duration: 10000,
      });
    }
  };

  const openDeleteFormModal = (form) => {
    setFormDelete(form);
    onOpen();
  };

  return (
    <Flex direction="column">
      <Card
        my="22px"
        overflowX={{ sm: 'scroll', xl: 'hidden' }}
        pb="0px"
      >
        <CardHeader>
          <Flex direction="row" justify="space-between">
            <Text fontSize="lg" color={textColor} fontWeight="bold">
              Forms
            </Text>
            <Button size="sm" colorScheme="blue" onClick={handleNewform} isLoading={isLoading}>New form</Button>
          </Flex>
        </CardHeader>
        <CardBody>
          <Table color={textColor}>
            <Thead>
              <Tr>
                <Th borderColor={borderColor} w="70%">
                  Form Name
                </Th>
                <Th borderColor={borderColor}>Submissions</Th>
                <Th borderColor={borderColor} />
              </Tr>
            </Thead>
            <Tbody>
              {rta.isFetching ? <TableFallback cols={2} />
                : rta.data.map((row, r) => (
                  <FormRow row={row} key={r} onDelete={openDeleteFormModal} />
                ))}
            </Tbody>
          </Table>
          <DeleteFormModal isOpen={isOpen} onClose={onClose} form={formDelete} />
        </CardBody>
      </Card>
    </Flex>
  );
};

export default FormListPage;
